// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 372 ? "soundwave" : chunkId) + "." + {"132":"5edb904f","372":"8868e359","941":"5ae657d5"}[chunkId] + ".css";
};